import React, { useEffect } from 'react';
import {
  useAppInsightsContext,
  useTrackEvent,
} from '@microsoft/applicationinsights-react-js';
import imagensPrevidencia from '@asserts/images/ouvidoria';
import { BannerOuvidoria, OuvidoriaContato, OuvidoriaAviso } from '../sections';
import { Page, Section } from '../../../components/shared/pages';
import SeguridadePageLayout from '../../../components/shared/layout/pageLayouts/seguridade';

export const HomePage = (props) => {
  const appInsights = useAppInsightsContext();
  const trackOuvidoria = useTrackEvent(appInsights, 'AA_Ouvidoria');

  useEffect(() => {
    const ouvidoriaEvent = {
      event: 'AA.navegacao',
      virtualPageTitle: 'Caixa Vida e Previdência - Ouvidoria',
      virtualPageURL: '/ouvidoria',
    };
    trackOuvidoria(ouvidoriaEvent);
  }, [trackOuvidoria]);

  return (
    <Page {...props} images={imagensPrevidencia} banner={BannerOuvidoria}>
      <SeguridadePageLayout.Tab eventKey="ouvidoria">
        <>
          <Section
            id="ouvidoria-aviso"
            as={OuvidoriaAviso}
            title="Indisponibilidade temporária."
            sectionName="Aviso"
            sectionLayout={null}
          />
          <Section
            id="ouvidoria-contato"
            as={OuvidoriaContato}
            title="Se preferir, você pode abrir uma ocorrência para a Ouvidoria por telefone:"
            sectionName="solicitar protocolo"
          />
        </>
      </SeguridadePageLayout.Tab>
    </Page>
  );
};

export default HomePage;
